<div class="row">
  @if (supportsTwofourGhz()) {
    <div class="col-12 col-lg-6">
      <kpi-data [title]="'2.4 GHz'" [kpiItems]="kpiItems()" [kpiRows]="kpiRowsTwofour()" />
    </div>
  }
  @if (supportsFiveGhz()) {
    <div class="col-12 col-lg-6">
      <kpi-data [title]="'5 GHz'" [kpiItems]="kpiItems()" [kpiRows]="kpiRowsFive()" />
    </div>
  }
  @if (supportsSixGhz()) {
    <div class="col-12 col-lg-6">
      <kpi-data [title]="'6 GHz'" [kpiItems]="kpiItems()" [kpiRows]="kpiRowsSix()" />
    </div>
  }
</div>
